import { ProjectLeaderboardView } from "../../components/LeaderboardView/ProjectLeaderboardView";

export const ProjectLeaderboardPage = () => {
  return <ProjectLeaderboardView />;
};
